// contentPageData.ts
export interface ContentRow {
  id: string;
  section: string;
  title: string;
  contentType: string;
  author: string;
  status: 'Published' | 'Draft' | 'Unpublish';
}

export const status = [
  { value: 'all-status', label: 'All Status' },
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
  { value: 'unpublish', label: 'Unpublish' },
];

export const companyData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-default-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Hero sector', title: 'Sharping digital payment', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Service', title: 'Our Solution', contentType: 'Section', author: 'Admin', status: 'Draft' },
  { id: '04', section: 'Contact', title: 'Ready to Empower your agents', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '05', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Unpublish' },
];

export const productData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-default-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Hero sector', title: 'Sharping digital payment', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Our mission', title: 'Driving the future', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '04', section: 'Our value', title: 'Secure.smart.Digital', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '05', section: 'Defferentiators', title: 'Why choose us', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '06', section: 'Join us', title: 'Driven your talents', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '07', section: 'Contact us', title: 'Get in touch', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '08', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

export const careerData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-default-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Hero sector', title: 'Transform your skill to opportunities', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Join us', title: 'Job seekers', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '04', section: 'Our principle', title: 'Find talent your way', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '05', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

export const contactData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-defualt-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Contact type', title: 'Get in touch', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

export const saleData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-defualt-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Contact form', title: 'let talk about your project', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

export const businessData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-defualt-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Contact form', title: 'let talk about your project', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

export const jobDetailData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-default-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Job Detail Hero', title: 'Job Detail Banner', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Job Description', title: 'Role Description', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '04', section: 'Requirements', title: 'Job Requirements', contentType: 'Section', author: 'Admin', status: 'Draft' },
  { id: '05', section: 'Benefits', title: 'Role Benefits', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '06', section: 'Apply Form', title: 'Job Application Form', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '07', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

export const jobPositionData: ContentRow[] = [
  { id: '01', section: 'Header', title: 'scl-default-v1', contentType: 'Navigation item', author: 'Panha-uiux', status: 'Published' },
  { id: '02', section: 'Position List', title: 'All Job Positions', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '03', section: 'Filter', title: 'Position Filter Bar', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '04', section: 'Position Card', title: 'Job Position Cards', contentType: 'Section', author: 'Admin', status: 'Draft' },
  { id: '05', section: 'Pagination', title: 'Position Pagination', contentType: 'Section', author: 'Admin', status: 'Published' },
  { id: '06', section: 'Footer', title: 'scl-footer-v1', contentType: 'Navigation item', author: 'Admin', status: 'Published' },
];

// Route to data + title mapping
export interface ContentPageConfig {
  title: string;
  description: string;
  data: ContentRow[];
}

export const contentPageConfigMap: Record<string, ContentPageConfig> = {
  company: {
    title: 'Content',
    description: 'Controls how company content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: companyData,
  },
  product: {
    title: 'Content',
    description: 'Controls how product page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: productData,
  },
  career: {
    title: 'Content',
    description: 'Controls how career page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: careerData,
  },
  contact: {
    title: 'Content',
    description: 'Controls how contact page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: contactData,
  },
  sale: {
    title: 'Content',
    description: 'Controls how sale page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: saleData,
  },
  business: {
    title: 'Content',
    description: 'Controls how business page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: businessData,
  },
  'job-detail': {
    title: 'Content',
    description: 'Controls how job detail page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: jobDetailData,
  },
  'job-position': {
    title: 'Content',
    description: 'Controls how job position page content is created, reviewed, published, and managed to maintain quality and consistency.',
    data: jobPositionData,
  },
};